import { Injectable } from '@angular/core';
@Injectable()
export class Sha1Service {

  getEncode(strUni): any {
    let strUtf = strUni.replace(
      /[\u0080-\u07ff]/g,
      function (c) {
        const cc = c.charCodeAt(0);
        return String.fromCharCode(0xc0 | cc >> 6, 0x80 | cc & 0x3f);
      }
    );
    strUtf = strUtf.replace(
      /[\u0800-\uffff]/g,
      function (c) {
        const cc = c.charCodeAt(0);
        return String.fromCharCode(0xe0 | cc >> 12, 0x80 | cc >> 6 & 0x3F, 0x80 | cc & 0x3f);
      }
    );
    return strUtf;
  }

  getDecode(strUtf): any {
    let strUni = strUtf.replace(
      /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
      function (c) {
        const cc = ((c.charCodeAt(0) & 0x0f) << 12) | ((c.charCodeAt(1) & 0x3f) << 6) | (c.charCodeAt(2) & 0x3f);
        return String.fromCharCode(cc);
      }
    );
    strUni = strUni.replace(
      /[\u00c0-\u00df][\u0080-\u00bf]/g,
      function (c) {
        const cc = (c.charCodeAt(0) & 0x1f) << 6 | c.charCodeAt(1) & 0x3f;
        return String.fromCharCode(cc);
      }
    );
    return strUni;
  }

  getF(s, x, y, z): any {
    switch (s) {
      case 0: return (x & y) ^ (~x & z);
      case 1: return x ^ y ^ z;
      case 2: return (x & y) ^ (x & z) ^ (y & z);
      case 3: return x ^ y ^ z;
    }
  }

  getROTL(x, n): any {
    return (x << n) | (x >>> (32 - n));
  }

  getToHexStr(n): any {
    let s = '', v;
    for (let i = 7; i >= 0; i--) { v = (n >>> (i * 4)) & 0xf; s += v.toString(16); }
    return s;
  }

  setHash(msg, utf8encode, tcase): any {
    const me = this;
    utf8encode = (typeof utf8encode == 'undefined') ? true : utf8encode;
    if (tcase == null) tcase = 2;
    if (utf8encode) msg = me.getEncode(msg);

    const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];

    msg += String.fromCharCode(0x80);

    const l = msg.length / 4 + 2;
    const N = Math.ceil(l / 16);
    const M = new Array(N);

    for (let i = 0; i < N; i++) {
      M[i] = new Array(16);
      for (let j = 0; j < 16; j++) {
        M[i][j] = (msg.charCodeAt(i * 64 + j * 4) << 24) | (msg.charCodeAt(i * 64 + j * 4 + 1) << 16) |
          (msg.charCodeAt(i * 64 + j * 4 + 2) << 8) | (msg.charCodeAt(i * 64 + j * 4 + 3));
      }
    }
    M[N - 1][14] = ((msg.length - 1) * 8) / Math.pow(2, 32); M[N - 1][14] = Math.floor(M[N - 1][14])
    M[N - 1][15] = ((msg.length - 1) * 8) & 0xffffffff;

    let H0 = 0x67452301;
    let H1 = 0xefcdab89;
    let H2 = 0x98badcfe;
    let H3 = 0x10325476;
    let H4 = 0xc3d2e1f0;

    const W = new Array(80); let a, b, c, d, e;
    for (let i = 0; i < N; i++) {

      for (let t = 0; t < 16; t++) W[t] = M[i][t];
      for (let t = 16; t < 80; t++) W[t] = me.getROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);

      a = H0; b = H1; c = H2; d = H3; e = H4;

      for (let t = 0; t < 80; t++) {
        const s = Math.floor(t / 20);
        const T = (me.getROTL(a, 5) + me.getF(s, b, c, d) + e + K[s] + W[t]) & 0xffffffff;
        e = d;
        d = c;
        c = me.getROTL(b, 30);
        b = a;
        a = T;
      }

      H0 = (H0 + a) & 0xffffffff;
      H1 = (H1 + b) & 0xffffffff;
      H2 = (H2 + c) & 0xffffffff;
      H3 = (H3 + d) & 0xffffffff;
      H4 = (H4 + e) & 0xffffffff;
    }

    let vhash = me.getToHexStr(H0) + me.getToHexStr(H1) +
      me.getToHexStr(H2) + me.getToHexStr(H3) + me.getToHexStr(H4);
    if (tcase == 1)
      vhash = vhash.toLowerCase();
    else if (tcase == 2)
      vhash = vhash.toUpperCase();
    return vhash;
  }

  getHash(msg, salt, itr): any {
    const me = this;
    let strmsg='';
    if (itr == 0) {
      strmsg = me.setHash(msg, true, null);
      const arMsg = [strmsg.substr(0, 4), strmsg.substr(4, strmsg.length - 8), strmsg.substr(strmsg.length - 4, 4)];
      strmsg = arMsg[0].split('').reverse().join('') + arMsg[1].split('').reverse().join('') + arMsg[2].split('').reverse().join('');
    } else {
      salt = salt.split('').reverse().join('');
      strmsg = me.setHash(msg + salt, true, null);
      for (let i = 1; i < itr; i++) {
        strmsg = me.setHash(strmsg + salt, true, null);
      }
    }
    return strmsg;
  }

}



// WEBPACK FOOTER //
// ./src/providers/secrypt.ts